import React from 'react';
import { Input, Textarea, Button, Select, PaperClip, Modal } from 'components';
import { NotificationService } from 'services';
import { Globals, Constants } from 'utils';
import ModalCandidates from './modal-candidates';

interface Props {
  onClose?: any;
}

class CreateNotification extends React.Component<Props> {
  state = {
    form: {
      title: '',
      subject: '',
      description: '',
      segment_type: '',
      verified: '',
      image: '',
    },
    selected_users: [] as any[],
    visible_candidates: false,
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  isCustom = () => this.state.form.segment_type === Constants.NOTIFICATION_SEGMENT_TYPE.CUSTOM;
  isAllLawyers = () =>
    this.state.form.segment_type === Constants.NOTIFICATION_SEGMENT_TYPE.ALL_LAWYERS;

  openCandidates = () => {
    this.setState({ visible_candidates: true });
  };

  onCloseCandidates = (users?: any[]) => {
    this.setState({
      visible_candidates: false,
      selected_users: users ?? this.state.selected_users,
    });
  };

  removeUser = (id: number) => {
    this.setState({
      selected_users: this.state.selected_users.filter((u: any) => u.id !== id),
    });
  };

  submit = async (e: any) => {
    e.preventDefault();

    if (!this.state.form.title || !this.state.form.subject || !this.state.form.description) {
      Globals.showError('Por favor, complete el título, el asunto y el mensaje');
      return;
    }

    if (!this.state.form.segment_type) {
      Globals.showError('Por favor, seleccione a quién va dirigida la notificación');
      return;
    }

    if (this.isCustom() && this.state.selected_users.length === 0) {
      Globals.showError('Por favor, seleccione al menos un destinatario');
      return;
    }

    const payload: any = {
      title: this.state.form.title,
      subject: this.state.form.subject,
      description: this.state.form.description,
      segment_type: this.state.form.segment_type,
    };

    if (this.isCustom()) {
      payload.user_ids = JSON.stringify(this.state.selected_users.map((u: any) => u.id));
    } else if (this.isAllLawyers() && this.state.form.verified !== '') {
      payload.filters = JSON.stringify({ verified: Number(this.state.form.verified) });
    }

    // Por ahora solo se admite una imagen por notificación.
    if (this.state.form.image) {
      payload.hasFile = true;
      // @ts-ignore
      payload.images = this.state.form.image?.value || '';
    }

    await NotificationService.admin.send(payload);
    Globals.showSuccess('Se ha enviado la notificación correctamente');
    this.props.onClose();
  };

  render() {
    return (
      <div id='modal-create-notification'>
        <Modal
          className='modal-notification-candidates'
          visible={this.state.visible_candidates}
          title='Seleccionar destinatarios'
          onClose={() => this.onCloseCandidates()}
        >
          <ModalCandidates
            selected={this.state.selected_users}
            onConfirm={(users: any[]) => this.onCloseCandidates(users)}
            onClose={() => this.onCloseCandidates()}
          />
        </Modal>

        <div className='row'>
          {/* Izquierda: título, asunto, a quién va dirigido e imagen -- mismo
              esquema que modal-create.tsx de Trámites (col-md-4 con el form). */}
          <form onSubmit={this.submit} className='col-md-4'>
            <div className='container-inputs'>
              <div className='row'>
                <div className='col-md-12'>
                  <Input
                    color='white'
                    value={this.state.form.title}
                    name='title'
                    label='Título'
                    onChange={this.change}
                  />
                </div>
                <div className='col-md-12'>
                  <Input
                    color='white'
                    value={this.state.form.subject}
                    name='subject'
                    label='Asunto'
                    onChange={this.change}
                  />
                </div>
                <div className='col-md-12'>
                  <Select
                    color='white'
                    placeholder='Seleccionar'
                    label='Dirigido a'
                    name='segment_type'
                    onChange={this.change}
                    value={this.state.form.segment_type}
                    options={[
                      {
                        value: Constants.NOTIFICATION_SEGMENT_TYPE.ALL_CLIENTS,
                        label: 'Todos los clientes',
                      },
                      {
                        value: Constants.NOTIFICATION_SEGMENT_TYPE.ALL_LAWYERS,
                        label: 'Todos los abogados',
                      },
                      {
                        value: Constants.NOTIFICATION_SEGMENT_TYPE.CUSTOM,
                        label: 'Personalizado',
                      },
                    ]}
                  />
                </div>

                {this.isAllLawyers() && (
                  <div className='col-md-12'>
                    <Select
                      color='white'
                      placeholder='Todos'
                      label='Filtrar por verificación (opcional)'
                      name='verified'
                      onChange={this.change}
                      value={this.state.form.verified}
                      options={[
                        { value: Constants.VERIFIED.VERIFIED.toString(), label: 'Verificado' },
                        { value: Constants.VERIFIED.PENDING.toString(), label: 'Pendiente' },
                        { value: Constants.VERIFIED.IN_PROCESS.toString(), label: 'En proceso' },
                        { value: Constants.VERIFIED.REJECTED.toString(), label: 'Rechazado' },
                      ]}
                    />
                  </div>
                )}

                {this.isCustom() && (
                  <div className='col-md-12'>
                    <div className='row' style={{ marginTop: 10 }}>
                      <div className='col-md-8'>
                        <h4 style={{ marginTop: 7 }}>
                          Destinatarios ({this.state.selected_users.length})
                        </h4>
                      </div>
                      <div className='col-md-4 text-right'>
                        <Button
                          type='button'
                          className='btn-add'
                          onClick={() => this.openCandidates()}
                        >
                          Seleccionar
                        </Button>
                      </div>
                    </div>
                    {this.state.selected_users.map((u: any) => {
                      const fullName = `${u.name || ''} ${u.lastname || ''}`.trim();
                      return (
                        <div className='tag' key={u.id}>
                          <p>{fullName}</p>
                          <a
                            href='#'
                            onClick={(e: any) => {
                              e.preventDefault();
                              this.removeUser(u.id);
                            }}
                          >
                            ✕
                          </a>
                        </div>
                      );
                    })}
                  </div>
                )}

                <div className='col-md-12'>
                  <h4>Imagen</h4>
                  <p>Opcional. Formatos jpg, jpeg o png.</p>
                  <PaperClip
                    formats={['png', 'jpg', 'jpeg']}
                    successText='Imagen adjunta'
                    pendingText='Subir imagen'
                    value={this.state.form.image}
                    onChange={(e: any) => {
                      this.setState({
                        form: {
                          ...this.state.form,
                          image: e.target,
                        },
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className='text-center'>
              <Button type='submit'>Enviar</Button>
            </div>
          </form>

          {/* Derecha: mensaje, en un campo amplio (igual que el editor de
              Trámites, pero acá es texto plano, no HTML). */}
          <div className='col-md-8'>
            <Textarea
              color='white'
              rows={20}
              value={this.state.form.description}
              name='description'
              label='Mensaje'
              onChange={this.change}
            />
            <p className='note'>
              Este mensaje es el que verá el usuario dentro del chat de notificaciones.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default CreateNotification;
